"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_3 = { class: "facility_name" };
const _hoisted_4 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_5 = { class: "zipcode" };
const _hoisted_6 = { class: "address" };
const vue_3 = require("vue");
const BssMapLatLng_vue_1 = __importDefault(require("./BssMapLatLng.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMapLandmarkInfobox',
    props: {
        data: {},
        movementSettings: {}
    },
    setup(__props) {
        const props = __props;
        const messages = (0, vue_3.inject)('messages');
        const infobox_messages = messages.l_infobox;
        function toZipcodeFormat(str) {
            if (str.trim().length == 7 && !isNaN(Number(str))) {
                str = str.trim();
                return str.slice(0, 3) + '-' + str.slice(3);
            }
            return str;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `infobox_landmark_${props.data.id}`,
                style: { "color": "#89684f", "width": "360px" }
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)(props.data.facility_name || '---'), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).zipcode) + " ", 1),
                        (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(toZipcodeFormat(props.data.zipcode || '')), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(props.data.address || ''), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", null, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createVNode)(BssMapLatLng_vue_1.default, {
                            longitude: props.data.longitude,
                            latitude: props.data.latitude
                        }, null, 8, ["longitude", "latitude"])
                    ])
                ])
            ], 8, _hoisted_1));
        };
    }
});
